/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { IsomorphicCarousel } from 'src/components/common/modules/carousel/uitk/carousel';
import { SlickSlider } from 'src/components/common/modules/carousel/slick/slick-carousel';
import { DealsCarouselViewsProps } from './types.d';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { Settings } from 'react-slick';
import MagicSliderDots from 'react-magic-slider-dots';
import { checkValue, getLocalizedMessage } from 'src/components/common/helper';
import { useEffect } from 'react';
import { useStores } from 'src/utils/useStore';

export const DealsCarousel = (props: DealsCarouselViewsProps) => {
  const { campaign, renderDealsCampaignCard, focusElement } = props;

  return (
    <UitkSpacing margin={{ blockstart: 'three' }}>
      <IsomorphicCarousel
        itemsVisible={{
          lg: 3,
          md: 2,
          sm: 1,
        }}
        buttonText={{
          nextButton: 'next',
          prevButton: 'prev',
        }}
        peek={true}
        pageBy={1}
        //peekWidth={24.8}
      >
        {campaign.offers!.map((offer, cardIndex) => {
          return (
            <UitkLayoutFlex key={`deals-carousel-${offer.name}-${cardIndex}`} blockSize="full_size" direction="column">
              <UitkLayoutFlexItem minWidth="full_width">
                <div ref={focusElement} tabIndex={-1} data-testid="deals-carousel">
                  {renderDealsCampaignCard(offer, cardIndex)}
                </div>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          );
        })}
      </IsomorphicCarousel>
    </UitkSpacing>
  );
};

export const DealsSlickCarousel = (props: DealsCarouselViewsProps) => {
  const { campaign, renderDealsCampaignCard, focusElement, isPagination = false } = props;
  const { context: storeContext } = useStores();

  useEffect(() => {
    const handleWindowResize = () => {
      setFinalStatus(1);
    };

    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const settings: Settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => {
      return <MagicSliderDots dots={dots} numDotsToShow={4} dotWidth={22} />;
    },
  };

  const gaTracking = {
    eventCategory: 'Slick carousel',
    eventAction: 'Hotel widget - carousel',
    eventLabel: 'slide-',
  };

  const slickAccessibilityData = {
    enabled: true,
    dotsAriaLabelBuilder: (current: number, total: number) =>
      (getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(), 'slick_dots_aria_label') || 'Slide ${1} of ${2}')
        .replaceAll('${1}', current)
        .replaceAll('${2}', total),
    prevButtonAriaLabel:
      getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(), 'slick_prev_button_aria_label') ||
      'Go to the previous slide in the carousel',
    nextButtonAriaLabel:
      getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(), 'slick_next_button_aria_label') ||
      'Go to the next slide in the carousel',
    totalSlides: campaign.length,
  };

  const setFinalStatus = (activeSlide) => {
    const slideStatus = document.querySelectorAll('.deals-carousel-slide-status');
    if (checkValue(slideStatus)) {
      slideStatus.forEach((element) => {
        const finalSlideStatus = activeSlide + ' / ' + parseInt(campaign.length);
        element.innerHTML = finalSlideStatus.toString();
      });
    }
  };

  const onSlickChange = (currentSlide: number, nextSlide: number) => {
    const updatedCurrentSlide = nextSlide + 1;
    setFinalStatus(updatedCurrentSlide);
  };

  if (isPagination) {
    settings.beforeChange = (currentSlide: number, nextSlide: number) => {
      onSlickChange(currentSlide, nextSlide);
    };
  }

  return (
    <UitkSpacing margin={{ blockstart: 'three' }}>
      <>
        {isPagination && <div className="deals-carousel-slide-status" id="deals-carousel-slide-status-label"></div>}
        <SlickSlider settings={settings} gaTracking={gaTracking} accessibilityData={slickAccessibilityData}>
          {campaign?.map((offer, cardIndex) => {
            return (
              <UitkLayoutFlex
                key={`deals-carousel-${offer.name}-${cardIndex}`}
                blockSize="full_size"
                direction="column"
              >
                <UitkLayoutFlexItem minWidth="full_width">
                  <div ref={focusElement} tabIndex={-1} data-testid="deals-carousel">
                    {renderDealsCampaignCard(offer, cardIndex)}
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            );
          })}
        </SlickSlider>
      </>
    </UitkSpacing>
  );
};

export default DealsCarousel;
